
  class postPopup extends HTMLElement {
    constructor() {
      super();
      this.popupCloseTitle = this.dataset.closeTitle;
      this.popupCloseLink = this.dataset.closeLink;
      this.colseBtn = this.querySelector(".popup-close");
      this.popupBackground = this.querySelector(".popup_background");
      this.mobileCloseBtn = this.querySelector(".mobile_close");
      
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      
      this.colseBtn.addEventListener('click', this.onCloseButtonClick.bind(this));
      this.popupBackground.addEventListener('click', this.onCloseButtonClick.bind(this));
      this.mobileCloseBtn.addEventListener('click', this.onCloseButtonClick.bind(this));
    }

    onCloseButtonClick () {
      this.classList.remove("open");
      window.history.pushState('page', this.popupCloseTitle,this.popupCloseLink);
      document.body.classList.remove("overflow");
    }
  }
  customElements.define('post-popup', postPopup);
  
  class postOpener extends HTMLElement {
    constructor() {
      super();
      this.popupId = this.dataset.modalId;
      this.popupTitle = this.dataset.modalTitle;
      this.popup = document.getElementById(this.popupId);
    }
    connectedCallback() {
      this.addEventListener('click', this.onButtonClick.bind(this));
    }
    
    onButtonClick() {
      this.popup.classList.add("open");
      window.history.pushState('page', this.popupTitle,"?"+this.popupId);
      document.body.classList.add("overflow");
    }
  }
  customElements.define('post-opener', postOpener);
